import {useMutation} from 'react-query';
import {postPaymentPromotion} from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
interface IUsePostPaymentPromotionProps {
  onSuccess?: () => void;
}
const usePostPaymentPromotion = ({
  onSuccess,
}: IUsePostPaymentPromotionProps) => {
  const {mutate, isLoading} = useMutation({
    mutationFn: (payload: PaymentPromotionPayload) => {
      return postPaymentPromotion(payload);
    },
    onSuccess: ({ipg_url}: PaymentPromotionData) => {
      window.location.replace(ipg_url);
      onSuccess && onSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {mutate, isLoading};
};

export default usePostPaymentPromotion;
